import React from "react";

export const MarginBottomDiv = ({ unit }) => (
    <div style={{ marginBottom: unit ? unit : '2rem'}}/>
)

export const MarginTopDiv = ({ unit }) => (
    <div style={{ marginTop: unit ? unit : '2rem'}}/>
)
